import {
  managedRelaySessionAtom,
  relayPrincipalKey,
  setManagedRelaySession,
} from "@maito/client-runtime/relay";
import * as Effect from "effect/Effect";

import { appAtomRegistry } from "../rpc/atomRegistry";

export function deactivateManagedRelayAuthentication(): void {
  setManagedRelaySession(appAtomRegistry, null);
}

export function activateManagedRelayAuthentication(
  accountId: string,
  organizationId: string,
  readClerkToken: () => Promise<string | null>,
): void {
  setManagedRelaySession(appAtomRegistry, {
    accountId: relayPrincipalKey(accountId, organizationId),
    readClerkToken,
  });
}

export function readManagedRelayClerkToken(): Promise<string | null> {
  const session = appAtomRegistry.get(managedRelaySessionAtom);
  return session === null ? Promise.resolve(null) : Effect.runPromise(session.readClerkToken());
}
